import React,{useState} from 'react';

import {makeStyles,Grid,ListItemText,Typography} from '@material-ui/core'
//import axios from 'axios';

const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
      backgroundColor: theme.palette.background.paper,
    },
  }));

  const fecha = ()=>{
      
      const f = new Date();
      return(f.getDate() + "-" + (f.getMonth() +1) + "-" + f.getFullYear() + " " + f.getHours() + ":" + f.getMinutes());
  }


const Listado = ({setStatus}) => {


    const classes = useStyles();

    const [track,setTrack] = useState({

          "NumeroAWB": "10000001",
          "Prefijo": "174",
          "Origen": "BOG",
          "AeropuertoOrigen": "BOGOTA",
          "Destino": "LIM",
          "AeropuertoDestino": "LIMA",
          "CargaCompletada": true,
          "CodigoAerolinea": "4L",
          "NumeroVuelo": "0151",
          "FechaVuelo": "2015-11-18T19:20:00",
          "Estatus": {
            "CargaRecepcionada": "2015-11-18T19:20:00",
            "CargaEnRuta":    "2015-11-18T00:00:00",
            "CargaEnDestino": "2015-11-18T21:47:49",
            "CargaEntregada": "undef"
          },
          "Piezas": "1",
          "GrossWeight": "161,00",
          "VolumeWeight": "142,00",
          "ChargeableWeight": "161,00",
          "UnidadPeso": "KG",
          "TipoCarga": "GC",
          "Naturaleza": "FERETRO",
          "Shipper": "HERRERA Y HERRERA LIMITADA",
          "Consignatario": "FUNERARIA CORONA DE CRISTO",
          "Agente": "undef",
          "Comentarios": "",
          "Pieces": "1"
      });

    // useEffect(()=>{
    //     axios.get("/tracking")
    //             .then(response =>{
    //                 setTrack(response.data.data);
    //                 setStatus(response.data.data.Estatus);
    //             })
    // },[setStatus]);
    
    const tmp = ()=>{
        
        setStatus(track.Estatus);
    } 


    tmp();
        

    return ( 
        <div className={classes.root}>

            <div style={{width:"100%",display:"flex",flexDirection:"row-reverse", marginBottom:10}}>
                <Typography variant="h6" align="left"> {`Fecha de consulta ${fecha()}`} </Typography>
            </div>
            {track
            ?   <Grid container spacing={1}> 

                    <Grid item xs={4}>
                         <ListItemText primary={`NumeroAWB: ${track.NumeroAWB}`} />
                    </Grid>

                    <Grid item xs={4}>
                        <ListItemText primary={`FechaVuelo: ${track.FechaVuelo.split("T")[0]}`} />
                    </Grid>

                    <Grid item xs={4}>
                         <ListItemText primary={`CodigoAerolinea: ${track.CodigoAerolinea}`} />
                    </Grid>

                    <Grid item xs={4}>
                        <ListItemText primary= {`Origen: ${track.Origen}`} />
                    </Grid>

                    <Grid item xs={4}>
                        <ListItemText primary={`Destino: ${track.Destino}`} />
                    </Grid>

                    <Grid item xs={4}>
                        <ListItemText primary={`NumeroVuelo: ${track.NumeroVuelo}`} />
                    </Grid>

                    <Grid item xs={4}>
                         <ListItemText primary={`AeropuertoOrigen: ${track.AeropuertoOrigen}`} />
                    </Grid>

                    <Grid item xs={4}>
                        <ListItemText primary={`AeropuertoDestino: ${track.AeropuertoDestino}`}  />
                    </Grid>

                    <Grid item xs={4}>
                        <ListItemText primary={`CargaCompletada: ${track.CargaCompletada}`} />
                    </Grid>

                    <Grid item xs={4}>
                         <ListItemText primary= {`Piezas: ${track.Piezas}`} />
                    </Grid>


               </Grid>
            :null
            }

            

        </div>

    );
}
 
export default Listado;